/** Fixed transfer geometry shared by realtime V3 upload and download clients. */
export const INLINE_TRANSFER_PART_SIZE = 512 * 1024;
export const INLINE_UPLOAD_MAX_PARTS = 1_000;
export const INLINE_TRANSFER_MAX_LOCATOR_ID = 2147483647n;
